import Vue from 'vue'
import Vuex from 'vuex'
import STATE from '@/store/state.js'
import MUTATIONS from '@/store/mutations.js'
import SERVER_ACTIONS from '@/store/actions/serverActions.js'
import HUB_ACTIONS from '@/store/actions/hubActions.js'
import NODES_ACTIONS from '@/store/actions/nodesActions.js'
import GETTERS from '@/store/getters.js'
import * as CONFIGS from '@/statics/configs.js'



import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: STATE,
  mutations: MUTATIONS,
  actions: {
    init: function (store) {
      document.addEventListener("visibilitychange", () => {
        if (document.hidden){
          store.state.hubs.forEach( (hub, index) => {
            store.commit('setHubStatus', {
              hubIndex: index,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          });
        }
      });
      store.dispatch('startStatusUpdate');
      store.commit('setAppBusy', false);

      // var encryptedMessageArray = '{"0":1,"1":118,"2":146,"3":36,"4":9,"5":75,"6":146,"7":36,"8":9,"9":8,"10":72,"11":0,"12":0,"13":164,"14":244,"15":242,"16":1,"17":188,"18":112,"19":4,"20":6,"21":55,"22":148,"23":36,"24":9,"25":7,"26":20,"27":1,"28":1,"29":11,"30":1,"31":129,"32":81,"33":1,"34":2,"35":129,"36":109,"37":0,"38":32,"39":129,"40":246,"41":0,"42":33,"43":129,"44":28,"45":0,"46":3,"47":129,"48":39,"49":0,"50":16,"51":130,"52":51,"53":223,"54":232,"55":1,"56":17,"57":130,"58":8,"59":72,"60":0,"61":0,"62":18,"63":130,"64":255,"65":149,"66":237,"67":1,"68":19,"69":130,"70":8,"71":72,"72":0,"73":0,"74":20,"75":130,"76":213,"77":76,"78":242,"79":1,"80":21,"81":130,"82":8,"83":72,"84":0,"85":0,"86":132,"87":146,"88":36,"89":9,"90":2,"91":19,"92":12,"93":1,"94":14,"95":32,"96":128,"97":1,"98":33,"99":128,"100":1,"101":16,"102":224,"103":1,"104":17,"105":224,"106":0,"107":16,"108":225,"109":255,"110":0,"111":17,"112":225,"113":0,"114":0,"115":1,"116":129,"117":212,"118":1,"119":2,"120":129,"121":66,"122":0,"123":16,"124":130,"125":61,"126":156,"127":239,"128":1,"129":17,"130":130,"131":8,"132":72,"133":0,"134":0,"135":18,"136":130,"137":145,"138":46,"139":230,"140":1,"141":19,"142":130,"143":8,"144":72,"145":0,"146":0,"147":20,"148":130,"149":103,"150":229,"151":234,"152":1,"153":21,"154":130,"155":8,"156":72,"157":0,"158":0,"159":149,"160":146,"161":36,"162":9,"163":2,"164":19,"165":12,"166":1,"167":14,"168":32,"169":128,"170":0,"171":33,"172":128,"173":1,"174":16,"175":224,"176":0,"177":17,"178":224,"179":0,"180":16,"181":225,"182":0,"183":0,"184":17,"185":225,"186":0,"187":0,"188":1,"189":129,"190":145,"191":1,"192":2,"193":129,"194":59,"195":0,"196":16,"197":130,"198":145,"199":201,"200":240,"201":1,"202":17,"203":130,"204":8,"205":72,"206":0,"207":0,"208":18,"209":130,"210":229,"211":91,"212":231,"213":1,"214":19,"215":130,"216":8,"217":72,"218":0,"219":0,"220":20,"221":130,"222":187,"223":18,"224":236,"225":1,"226":21,"227":130,"228":8,"229":72,"230":0,"231":0,"232":131,"233":146,"234":36,"235":9,"236":2,"237":19,"238":12,"239":1,"240":14,"241":32,"242":128,"243":0,"244":33,"245":128,"246":0,"247":16,"248":224,"249":0,"250":17,"251":224,"252":0,"253":16,"254":225,"255":0,"256":0,"257":17,"258":225,"259":0,"260":0,"261":1,"262":129,"263":180,"264":1,"265":2,"266":129,"267":70,"268":0,"269":16,"270":130,"271":7,"272":215,"273":229,"274":1,"275":17,"276":130,"277":8,"278":72,"279":0,"280":0,"281":18,"282":130,"283":241,"284":141,"285":234,"286":1,"287":19,"288":130,"289":8,"290":72,"291":0,"292":0,"293":20,"294":130,"295":199,"296":68,"297":239,"298":1,"299":21,"300":130,"301":8,"302":72,"303":0,"304":0,"305":94,"306":148,"307":36,"308":9,"309":7,"310":20,"311":1,"312":1,"313":12,"314":1,"315":129,"316":0,"317":0,"318":2,"319":129,"320":77,"321":0,"322":32,"323":129,"324":0,"325":0,"326":33,"327":129,"328":0,"329":0,"330":3,"331":129,"332":241,"333":0,"334":34,"335":129,"336":0,"337":0,"338":16,"339":130,"340":113,"341":236,"342":237,"343":1,"344":17,"345":130,"346":8,"347":72,"348":0,"349":0,"350":18,"351":130,"352":71,"353":163,"354":242,"355":1,"356":19,"357":130,"358":8,"359":72,"360":0,"361":0,"362":20,"363":130,"364":165,"365":53,"366":233,"367":1,"368":21,"369":130,"370":8,"371":72,"372":0,"373":0,"374":53,"375":146,"376":36,"377":9,"378":2,"379":20,"380":6,"381":1,"382":17,"383":16,"384":128,"385":0,"386":1,"387":129,"388":184,"389":13,"390":2,"391":129,"392":77,"393":0,"394":3,"395":129,"396":34,"397":0,"398":16,"399":225,"400":146,"401":9,"402":17,"403":225,"404":5,"405":0,"406":18,"407":225,"408":100,"409":0,"410":19,"411":225,"412":0,"413":0,"414":20,"415":225,"416":0,"417":0,"418":21,"419":225,"420":0,"421":0,"422":16,"423":130,"424":75,"425":112,"426":239,"427":1,"428":17,"429":130,"430":8,"431":72,"432":0,"433":0,"434":18,"435":130,"436":159,"437":2,"438":230,"439":1,"440":19,"441":130,"442":8,"443":72,"444":0,"445":0,"446":20,"447":130,"448":117,"449":185,"450":234,"451":1,"452":21,"453":130,"454":8,"455":72,"456":0,"457":0,"458":32,"459":226,"460":0,"461":0,"462":0,"463":0}';
      // encryptedMessageArray = JSON.parse(encryptedMessageArray);
      // var messageHeaderObject = messaging._extractHeaderFromMessage(encryptedMessageArray);
      // var receivedMessageObject = messaging._extractBodyFromMessage(messageHeaderObject, encryptedMessageArray, 27);
      // console.log(receivedMessageObject);
  
  
      // setTimeout( async () => {
      //   var hub = store.state.hubs[0];
      //   var messagingHook = new Messaging(new Logger(false));
        
      //   var rfData = [
      //     0,0,0,0,0,0,0,1,1,0,1,0,0,0,0,1,1,1,0,0,0,0,0,1
      //   ];

        //315
        // var rfData = [
        //   0,0,1,1,1,1,0,0,1,1,0,1,0,1,0,1,1,0,1,0,0,0,1,0
        // ];
        // var rfData = [
        //   1,1,1,0,1,1,1,1,1,0,1,0,0,1,1,0,1,1,0,0,0,0,0,1,0,0,0,0,0,1,0,1,
        //   0,1,0,
        //   1,
        //   0,1,0,
        // ];
        // var data = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(rfData, 360, 720, 4844, 1498, 717, 7853));
        // var data = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(rfData, 370, 1100, 378, 11168, 0, 0));

        // var data = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(rfData, 215, 640, [210 ,6655], [0, 0]));
        // messagingHook.init({
        //   psk: hub.psk,
        //   destinationUUID: hub.uuid,
        //   sourceUUID: store.state.user.uuid
        // });
        // var hubIstructions = await store.dispatch('readHubInstructions', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        // })
        // console.log("hubIstructions");
        // console.log(hubIstructions);
        // var eventMasks = await store.dispatch('getEventMasks', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        // })
        // console.log("eventMasks");
        // console.log(eventMasks);
        // var hubWatches = await store.dispatch('readHubWatches', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        // })
        // console.log("hubWatches");
        // console.log(hubWatches);
        // await store.dispatch('setNodesParameters', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        //   nodeUUID: 0x0924946B,
        //   bodyContent: {
        //     nodeActions: [
        //       {
        //         nodeUUID: 0x0924946B,
        //         actions: [
        //           {
        //             parameterId: 0x4600,
        //             //stop
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,6,19,220,5,212,2,103,1,106,1,210,2,108,1,44,32,164,164,146,164,146,73,36,148,146,73,41,84,149,34,]),
        //             //open
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,254,18,224,5,209,2,109,1,102,1,215,2,103,1,50,32,164,164,146,164,146,73,36,148,146,73,42,73,42,162,]),
        //             //close
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,115,16,210,5,213,2,100,1,108,1,205,2,215,2,179,30,164,164,146,164,146,73,36,148,146,73,42,73,82,81,0,]),

        //             // valueOfChange: messagingHook.utility.arrayTo64([24,0,3,109,1,106,1,214,2,104,1,215,2,213,2,170,170,169,0,]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,251,18,220,5,210,2,107,1,104,1,213,2,211,2,190,30,164,164,146,164,146,73,36,148,146,73,42,73,41,36,64,]),

        //             // valueOfChange: messagingHook.utility.arrayTo64([24,0,3,107,1,103,1,211,2,103,1,211,2,209,2,170,170,169,0,]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,115,16,210,5,213,2,100,1,108,1,205,2,215,2,179,30,164,164,146,164,146,73,36,148,146,73,42,73,82,81,0,]),

        //             // valueOfChange: messagingHook.utility.arrayTo64([24,0,3,108,1,105,1,214,2,102,1,214,2,213,2,170,170,169,0,]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,150,16,214,5,216,2,100,1,109,1,207,2,216,2,183,30,164,164,146,164,146,73,36,148,146,73,41,73,41,36,64,]),
                    
        //             // valueOfChange: messagingHook.utility.arrayTo64([50,0,3,224,0,2,26,221,0,122,2,144,2,204,0,169,36,169,41,74,74,84,168]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([50,0,3,217,0,128,2,139,2,210,0,218,0,21,26,58,174,182,214,246]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,98,1,217,2,204,2,110,1,249,18,224,5,203,2,194,30,53,170,183,90,253,251,117,209,0]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,236,18,217,5,100,1,212,2,206,2,107,1,208,2,167,30,164,164,146,82,164,164,170,165,85,41,84,170,32,]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([82,0,4,93,1,225,2,199,2,119,1,251,18,235,5,92,1,60,32,53,170,183,90,253,251,122,168,128]),
        //             // valueOfChange: messagingHook.utility.arrayTo64([50,0,3,122,1,160,43,118,1,68,4,138,4,113,1,164,148,164,164,148,149,74,164,]),
        //             valueOfChange: messagingHook.utility.arrayTo64(data),
        //             typeOfAction: CONFIGS.ACTION_TYPE_SET,
        //             timeDelay: 1
        //           }
        //         ]
        //       },
        //     ]
        //   }
        // })
        // await store.dispatch('setNodesParameters', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        //   nodeUUID: 0x092498A0,
        //   bodyContent: {
        //     nodeActions: [
        //       {
        //         nodeUUID: 0x092498A0,
        //         actions: [
        //           {
        //             parameterId: 0xE143,
        //             valueOfChange: 0x210,
        //             typeOfAction: CONFIGS.ACTION_TYPE_SET,
        //             timeDelay: 0
        //           },
        //           {
        //             parameterId: 0xE142,
        //             valueOfChange: 0xffff,
        //             typeOfAction: CONFIGS.ACTION_TYPE_SET,
        //             timeDelay: 0
        //           }
        //         ]
        //       },
        //     ]
        //   }
        // })
        // console.log("set parameter");
      //   //515
      //   var maskList = [{
      //     eventId: 515,
      //     isMasked: true,
      //   }];

      //   var messageContextObject = {
      //     messageType: messagingHook.UPLINK_PACKET_SET_EVENT_MASKS,
      //     bodyContent: {
      //       maskList: maskList
      //     },
      //   }
      //   var serializedMessageArray = messagingHook.createHubMessage(messageContextObject).serializedMessageArray.splice(19);
      //   await store.dispatch('setUplinkImitator', {
      //     messagingHook: messagingHook,
      //     hubUUID: hub.uuid,
      //     bodyContent: {
      //       imitatorsList: [{
      //         eventIdToWatch: 1,
      //         commandLength: serializedMessageArray.length,
      //         commandToSend: serializedMessageArray,
      //       }]
      //     }
      //   })
      //   console.log("setUplinkImitator done");
      // await store.dispatch('setUplinkImitator', {
      //   messagingHook: messagingHook,
      //   hubUUID: hub.uuid,
      //   imitatorsList: []
      // });
        // var imitators = await store.dispatch('getUplinkImitators', {
        //   messagingHook: messagingHook,
        //   hubUUID: hub.uuid,
        // });
        // console.log(imitators);



      //   // store.dispatch('setEventNotifications', {
      //   //   messagingHook: messagingHook,
      //   //   hubUUID: hub.uuid,
      //   //   bodyContent: {
      //   //     notificationsList: [
      //   //       {
      //   //         eventId: 12,
      //   //         isNotified: true,
      //   //       },
      //   //     ]
      //   //   }

      //   // })
      //   // ,then( (response) => {
      //   //   console.log('then');
      //   //   console.log(response);
      //   // })
      //   // .catch( (response) => {
      //   //   console.log('catch');
      //   //   console.log(response);
      //   // })

      //   // var serializedMessage = messagingHook.createHubMessage(messageContextObject).serializedMessageArray;
      //   // var imitationOfMessage = serializedMessage.splice(19);
  
      //   // store.dispatch('getUplinkImitators', {
      //   //   messagingHook: messagingHook,
      //   //   hubUUID: hub.uuid,
      //   // })
  
      //   // store.dispatch('setUplinkImitator', {
      //   //   messagingHook: messagingHook,
      //   //   hubUUID: hub.uuid,
      //   //   bodyContent: {
      //   //     imitatorsList: []
      //   //   }
      //   // })
      //   // .then( (response) => {
      //   //   console.log("then");
      //   //   console.log(response);
      //   // })
      //   // .catch( (response) => {
      //   //   console.log("catch");
      //   //   console.log(response);
      //   // })
      // }, 3000)
    },
    saveDatabase: function (store, hubUUID) {
      return new Promise(function (resolve, reject) {
        var hub = store.getters.getHubByUUID(hubUUID);
        var database = {};
        database.hub = {
          name: hub.name,
          color: hub.color,
          uuid: hub.uuid,
        };
        database.nodes = [];
        for(var i = 0; i < store.state.nodes.length; i++){
          if(store.state.nodes[i].hubUUID == hub.uuid){
            database.nodes.push(store.state.nodes[i]);
          }
        }
        database.widgets = [];
        for(i = 0; i < store.state.widgets.length; i++){
          if(store.state.widgets[i].hubUUID == hub.uuid){
            database.widgets.push(store.state.widgets[i]);
          }else if(store.state.widgets[i].type == "folderWidget"){
            database.widgets.push(store.state.widgets[i]);
          }
        }
        database.schedules = [];
        for(i = 0; i < store.state.schedules.length; i++){
          if(store.state.schedules[i].hubUUID == hub.uuid){
            database.schedules.push(store.state.schedules[i]);
          }
        }
        database.users = hub.users;
        store.dispatch('addSnapshot', {
          userUUID: store.state.user.uuid,
          token: store.state.user.loginToken,
          hubUUID: hub.uuid,
          content: encodeURI(JSON.stringify(database)),
          name: store.state.user.uuid + "-" + hub.uuid,
        })
        .then( response => {
          if(response.data.status == 'success'){
            resolve();
          }else{
            reject({errorCode: 1});
          }
        })
        .catch( () => {
          reject({errorCode: 2});
        });
      });
    },
    ...SERVER_ACTIONS,
    ...HUB_ACTIONS,
    ...NODES_ACTIONS,
  },
  getters: GETTERS,
})
